import { PaletteOptions } from '@mui/material';

export const palette: PaletteOptions = {
  text: {
    primary: '#2E2E2E',
    secondary: '#919191',
  },
  primary: {
    main: '#4330BB',
    dark: '#3622B7',
    light: '#4330BB1A',
    contrastText: '#FFFFFF',
  },
  primaryExtended: {
    opacityBackgroundText: '#4330BB',
    opacityBackgroundBackground: '#4330BB1A',
  },
  secondary: {
    main: '#FF0000',
    contrastText: '#FF0000',
  },
  background: {
    default: '#FFFFFF',
    paper: '#F5F5F5',
  },
  backgroundExtended: {
    card: '#FFFFFF',
  },
  backdrop: {
    default: '#0000004D',
  },
  common: {
    black: '#000000',
    white: '#FFFFFF',
  },
  error: {
    main: '#FF7B6B',
    dark: '#FF5B47',
    light: '#FF7B6B33',
    contrastText: '#FFFFFF',
  },
  warning: {
    main: '#FF9500',
    dark: '#D86700',
    light: '#FF95002E',
    contrastText: '#FFFFFF',
  },
  info: {
    main: '#8C88EF',
    dark: '#514CD6',
    light: '#8C88EF33',
    contrastText: '#FFFFFF',
  },
  success: {
    main: '#72C1BC',
    dark: '#4DA29D',
    light: '#72C1BC24',
    contrastText: '#FFFFFF',
  },
  divider: '#F0F0F0',
  grey: {
    900: '#191518',
    800: '#979797',
    700: '#A7A7A7',
    600: '#B7B7B7',
    500: '#D5D5D5',
    400: '#E2E2E2',
    300: '#EDEDED',
    200: '#F2F2F2',
    100: '#F4F4F4',
    50: '#F7F7F7',
  },
  brown: {
    900: '#FF0000',
    800: '#FF0000',
    700: '#FF0000',
    600: '#FF0000',
    500: '#FF0000',
    400: '#FF0000',
    300: '#FF0000',
    200: '#FF0000',
    100: '#FF0000',
    50: '#FF0000',
  },
};
